import React from 'react'

const UsecaseEngineers = ({ style = {}, ...props }) => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
      {...props}>
      <title>usecase-engineers</title>
      <defs>
        <linearGradient
          x1="50%"
          y1="100%"
          x2="50%"
          y2="3.061617e-15%"
          id="linearGradient-1">
          <stop stopColor="#FFFFFF" stopOpacity="0" offset="0%" />
          <stop stopColor="#FFFFFF" offset="100%" />
        </linearGradient>
        <path
          d="M10.2555408,-4.14336123e-16 L21.7444592,4.14336123e-16 C25.3105342,-2.4074122e-16 26.6036791,0.371302445 27.9073828,1.06853082 C29.2110865,1.76575919 30.2342408,2.78891348 30.9314692,4.09261719 C31.6286976,5.39632089 32,6.68946584 32,10.2555408 L32,21.7444592 C32,25.3105342 31.6286976,26.6036791 30.9314692,27.9073828 C30.2342408,29.2110865 29.2110865,30.2342408 27.9073828,30.9314692 C26.6036791,31.6286976 25.3105342,32 21.7444592,32 L10.2555408,32 C6.68946584,32 5.39632089,31.6286976 4.09261719,30.9314692 C2.78891348,30.2342408 1.76575919,29.2110865 1.06853082,27.9073828 C0.371302445,26.6036791 1.60494146e-16,25.3105342 -2.76224082e-16,21.7444592 L2.76224082e-16,10.2555408 C-1.60494146e-16,6.68946584 0.371302445,5.39632089 1.06853082,4.09261719 C1.76575919,2.78891348 2.78891348,1.76575919 4.09261719,1.06853082 C5.39632089,0.371302445 6.68946584,2.4074122e-16 10.2555408,-4.14336123e-16 Z"
          id="path-2"
        />
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="Group-12" transform="translate(0, -217)">
          <g id="Group-10-Copy" transform="translate(0, 216)">
            <g id="usecase-engineers" transform="translate(0, 1)">
              <g id="Rectangle">
                <use fill="#77CA34" xlinkHref="#path-2" />
                <use
                  fillOpacity="0.15"
                  fill="url(#linearGradient-1)"
                  xlinkHref="#path-2"
                />
              </g>
              <g
                id="code-alt"
                transform="translate(6, 8)"
                fill="#FFFFFF"
                fillRule="nonzero">
                <path
                  d="M5.40640026,6.58583605 C5.89368064,6.31119901 6.19364279,5.79422302 6.19006164,5.23527422 C6.18641593,4.67632543 5.87979491,4.16326369 5.38900444,3.8949381 C4.89821398,3.62661251 4.3004003,3.64520054 3.82726007,3.94349796 C2.37415379,4.86540141 1.14237193,6.09606512 0.219630865,7.54785234 C-0.0732102882,8.03536502 -0.0732102882,8.64445983 0.219630865,9.13197251 C1.14237193,10.5837597 2.37415379,11.8144234 3.82726007,12.7363269 C4.29969716,13.0193027 4.88735002,13.0289698 5.36885548,12.7616865 C5.85036094,12.4944033 6.15256687,11.9907765 6.16163522,11.4405175 C6.17070357,10.8902584 5.88525664,10.3769646 5.41281953,10.0939888 C4.67171955,9.60997609 4.00560001,9.02008791 3.43568466,8.34311914 C3.99004629,7.65178888 4.65612069,7.05785169 5.40640026,6.58583605 L5.40640026,6.58583605 Z M18.7713184,7.55426578 C17.8485774,6.10247856 16.6167955,4.87181485 15.1636892,3.9499114 C14.6912521,3.66693559 14.1035993,3.65726856 13.6220938,3.92455177 C13.1405884,4.19183499 12.8383825,4.69546179 12.8293141,5.24572082 C12.8202458,5.79597985 13.1056927,6.30927368 13.5781298,6.59224949 C14.3192297,7.0762622 14.9853493,7.66615038 15.5552646,8.34311914 C15.000046,9.0395737 14.3317074,9.63793079 13.5781298,10.1132291 C13.1056927,10.3962049 12.8202458,10.9094988 12.8293141,11.4597578 C12.8383825,12.0100168 13.1405884,12.5136436 13.6220938,12.7809268 C14.1035993,13.0482101 14.6912521,13.038543 15.1636892,12.7555672 C16.6167955,11.8336638 17.8485774,10.6030001 18.7713184,9.15121283 C19.073902,8.66015523 19.0763797,8.04131266 18.7777377,7.54785234 L18.7713184,7.55426578 Z M9.84853444,0.967660895 L6.63889992,14.435889 C6.4849908,15.1203894 6.91006086,15.8014351 7.59301146,15.9645629 C8.27596205,16.1276908 8.96338309,15.7123721 9.13599558,15.0323391 L12.3456301,1.564111 C12.4995392,0.879610598 12.0744692,0.198564944 11.3915186,0.0354370512 C10.708568,-0.127690842 10.0211469,0.287627937 9.84853444,0.967660895 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default UsecaseEngineers
